import { ScreenSize, useScreenSize as useScreenSizeListener } from '@spritz-finance/ui'
import React, { useContext } from 'react'

const ScreenSizeState = React.createContext<
    { isMobile: boolean; isDesktop: boolean; isTablet: boolean; size: ScreenSize } | undefined
>(undefined)

export const useScreenSize = () => {
    const context = useContext(ScreenSizeState)
    if (!context) throw new Error('Cannot use useScreenSize outside of a <ScreenSizeContext />')
    return context
}

export const ScreenSizeProvider: React.FC = ({ children }) => {
    const size = useScreenSizeListener()
    return (
        <ScreenSizeState.Provider
            value={{
                size,
                isMobile: size === ScreenSize.MOBILE,
                isDesktop: size === ScreenSize.DESKTOP,
                isTablet: size === ScreenSize.TABLET,
            }}
        >
            {children}
        </ScreenSizeState.Provider>
    )
}
